import React from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { color, space, layout, border } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Body from 'theme/layouts/body';
import UserMenu from 'components/user-menu';

const Wrapper = styled.div`
  ${space}
  ${color}
  ${border}

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  /* On a phone this strip stays at the top of the screen and paints its own
     white: scrolled under, the language, the account and the burger used to mix
     with whatever passed beneath them. The left padding is the room the burger
     and the mark occupy, which are fixed at the same height. */
  @media (max-width: calc(${themeGet('breakpoints.0')} - 1px)) {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: ${themeGet('colors.white')};
    padding-left: 104px;
    min-height: 56px;
    align-items: center;
    box-shadow: 0 1px 0 ${themeGet('colors.grey_200')};
  }

  & > .left {
    display: flex;
    align-items: center;
  }

  & > .centered {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: ${themeGet('space.s')}px 0;
  }
`;

const UserBar = styled.div`
  ${layout}
  width: 100%;
`;

function Header({ style, title, bodyColor, componentLeft, component, noWarning }) {
  return (
    <Wrapper {...style}>
      <Head>
        <title>{title}</title>
      </Head>
      <Body bg={bodyColor} />

      <div className="left">{componentLeft}</div>
      <div className="centered">{component}</div>
      <UserBar maxWidth={['236px', '236px', '236px', '320px']}>
        <UserMenu noWarning={noWarning} />
      </UserBar>
    </Wrapper>
  );
}

export default Header;
